import { format } from 'date-fns'

export type DateFormatOption = {
  label: string
  value: string
  formatLabel: string
}

type DateFormatDefinition = {
  labelFormat: string
  value: string
}

const DATE_FORMAT_DEFINITIONS: DateFormatDefinition[] = [
  { labelFormat: 'MM/DD/YYYY', value: 'MM/dd/yyyy' },
  { labelFormat: 'DD/MM/YYYY', value: 'dd/MM/yyyy' },
  { labelFormat: 'YYYY-MM-DD', value: 'yyyy-MM-dd' },
  { labelFormat: 'DD-MMM-YYYY', value: 'dd-MMM-yyyy' },
  { labelFormat: 'MMM DD, YYYY', value: 'MMM dd, yyyy' }
]

const DATETIME_FORMAT_DEFINITIONS: DateFormatDefinition[] = [
  { labelFormat: 'MM/DD/YYYY hh:mm A', value: 'MM/dd/yyyy hh:mm a' },
  { labelFormat: 'DD/MM/YYYY HH:mm', value: 'dd/MM/yyyy HH:mm' },
  { labelFormat: 'YYYY-MM-DD HH:mm', value: 'yyyy-MM-dd HH:mm' },
  { labelFormat: 'DD-MMM-YYYY HH:mm', value: 'dd-MMM-yyyy HH:mm' },
  { labelFormat: 'MMM DD, YYYY hh:mm A', value: 'MMM dd, yyyy hh:mm a' }
]

// Default date: December 25, 2025
const DEFAULT_DATE = new Date(2025, 11, 25) // Month is 0-indexed, so 11 = December

export function buildDateFormatOptions(now: Date = DEFAULT_DATE): DateFormatOption[] {
  return DATE_FORMAT_DEFINITIONS.map(def => ({
    label: `${def.labelFormat} (${format(now, def.value)})`,
    value: def.value,
    formatLabel: def.labelFormat
  }))
}

export function buildDateTimeFormatOptions(now: Date = DEFAULT_DATE): DateFormatOption[] {
  return DATETIME_FORMAT_DEFINITIONS.map(def => ({
    label: `${def.labelFormat} (${format(now, def.value)})`,
    value: def.value,
    formatLabel: def.labelFormat
  }))
}

export function getDefaultDateFormat(): string {
  return DATE_FORMAT_DEFINITIONS[0].value
}

export function getDefaultDateTimeFormat(): string {
  return DATETIME_FORMAT_DEFINITIONS[0].value
}

/**
 * Converts date-fns format string to vue2-datepicker format string.
 * vue2-datepicker uses uppercase format tokens (YYYY, DD, A) while date-fns uses lowercase (yyyy, dd, a).
 * @param formatString - The date-fns format string (e.g., 'dd/MM/yyyy HH:mm')
 * @returns The vue2-datepicker format string (e.g., 'DD/MM/YYYY HH:mm')
 */
export function toDatePickerFormat(formatString: string): string {
  if (!formatString) return formatString
  // Replace format tokens: yyyy -> YYYY, dd -> DD, a -> A
  // Using replace with regex for efficiency and to handle all occurrences
  return formatString.replace(/yyyy/g, 'YYYY').replace(/dd/g, 'DD').replace(/a/g, 'A')
}
